import { Fragment, useContext, useEffect, useState } from 'react';

import {
  Grid,
  Button
} from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Worker } from '@react-pdf-viewer/core';
import { Viewer } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';

import { SessionContext } from '../../context/session.context';
import { getFile } from '../../services/files.service';

export const CartaComponent = () => {

  const { logged } = useContext(SessionContext);
  const [cartaURL, setCartaURL] = useState('');
  const [loading, setLoading] = useState(true);

  const removeNavbar = () => {
    const navbar = document.getElementById('navbar-frida');
    navbar.parentElement?.removeChild(navbar);
  }

  const openExternal = () => {
    window.open(cartaURL, '_blank')
  }

  const getCartaUrl = async () => {
    const newPDF = await getFile('carta.pdf');
    setCartaURL(newPDF);
    setLoading(false);
  }

  useEffect(() => {
    if (!logged) {
      removeNavbar();
    }
    getCartaUrl()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Fragment>
      {loading ? (
        <CircularProgress />
      ) : (
        <Grid container justifyContent="center" spacing={2}>
          <Grid item xs={12} lg={8}>
            <Button variant="outlined" onClick={openExternal}>Abrir en otra ventana</Button>
          </Grid>
          <Grid item xs={12} lg={8}>
            <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.6.347/build/pdf.worker.min.js">
              <Viewer fileUrl={cartaURL} />
            </Worker>
          </Grid>
        </Grid>
      )}
      </Fragment>
  )
}